import videojs from 'video.js';
import './link';

/**
 * Plugin.
 * @param {Object} options
 * @param {string} options.href
 * @param {string} options.text
 * @param {string} [options.view]
 * @param {number} [options.mobileBreakpoint]
 * @param {string} [options.modificator]
 * @returns {void}
 */
export default function link(options) {
  this.ready(() => {
    this.addClass('vjs-link-plugin');
    this.addChild('Link', options, this.children_.length);
  });
}

videojs.registerPlugin('link', link);

